var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.667969C8.99995 0.667969 10.0667 0.868341 11 1.33496C11.3333 1.46826 11.4672 1.86788 11.334 2.20117C11.2007 2.53451 10.8001 2.66751 10.4668 2.53418C9.66691 2.20093 8.86655 2.00098 8 2.00098C4.66693 2.00115 2.00017 4.6679 2 8.00098C2 11.3342 4.66682 14.0008 8 14.001C11.3333 14.001 14 11.3343 14 8.00098V7.40137C14 7.00137 14.267 6.73438 14.667 6.73438C15.067 6.73438 15.334 7.00137 15.334 7.40137V8.00098C15.334 12.0676 12.0667 15.335 8 15.335C3.93348 15.3348 0.666992 12.0675 0.666992 8.00098C0.667166 3.93457 3.93359 0.668143 8 0.667969ZM14.8672 1.53418C15.1339 1.26784 15.5342 1.26762 15.8008 1.53418C16.0673 1.80074 16.0671 2.20111 15.8008 2.46777L8.4668 9.80176C8.33346 9.93487 8.13322 10.001 8 10.001C7.86667 10.0009 7.66643 9.93498 7.5332 9.80176L5.5332 7.80176C5.26664 7.5352 5.26686 7.13483 5.5332 6.86816C5.79987 6.6015 6.20013 6.6015 6.4668 6.86816L8 8.40137L14.8672 1.53418Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47019_31584",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.667969C8.99995 0.667969 10.0667 0.868341 11 1.33496C11.3333 1.46826 11.4672 1.86788 11.334 2.20117C11.2007 2.53451 10.8001 2.66751 10.4668 2.53418C9.66691 2.20093 8.86655 2.00098 8 2.00098C4.66693 2.00115 2.00017 4.6679 2 8.00098C2 11.3342 4.66682 14.0008 8 14.001C11.3333 14.001 14 11.3343 14 8.00098V7.40137C14 7.00137 14.267 6.73438 14.667 6.73438C15.067 6.73438 15.334 7.00137 15.334 7.40137V8.00098C15.334 12.0676 12.0667 15.335 8 15.335C3.93348 15.3348 0.666992 12.0675 0.666992 8.00098C0.667166 3.93457 3.93359 0.668143 8 0.667969ZM14.8672 1.53418C15.1339 1.26784 15.5342 1.26762 15.8008 1.53418C16.0673 1.80074 16.0671 2.20111 15.8008 2.46777L8.4668 9.80176C8.33346 9.93487 8.13322 10.001 8 10.001C7.86667 10.0009 7.66643 9.93498 7.5332 9.80176L5.5332 7.80176C5.26664 7.5352 5.26686 7.13483 5.5332 6.86816C5.79987 6.6015 6.20013 6.6015 6.4668 6.86816L8 8.40137L14.8672 1.53418Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47019_31584)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#00B3B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.fc44ead6207b7350f2f407286545f9be.svg";
export { ForwardRef as ReactComponent };